import { Flex } from "~/components/Flex";
import { Icon } from "~/components/Icon";
import { SvgExpenses } from "~/components/Icon/icons";
import { Text } from "~/components/Text";
import { useUser } from "~/presentation/core/contexts/UserContext";
import { asCurrency } from "~/utils/mask.utils";


export const CreditLimit = () => {
  const { user } = useUser();
  return (
    <Flex
      css={{
        position: "relative",
      }}
      direction="column"
    >
      <Flex
        gap="2"
        align="end"
        css={{
          borderRadius: "$md",
          p: "$2",
          border: " 1px solid $primary-base",

          cursor: "pointer",
        }}
      >
        

        <Flex gap="1" align="start" direction="column">
          <Flex gap="1" gapX="1" align="center">
            <Icon as={SvgExpenses} variant="primary"/>
            <Text variant="primary" fw="900" size="3" >
             Limite de Crédito
            </Text>
          </Flex>
          <Flex gap="1" align="start" direction="column" css={{
            mt: "$1"
          }}>
            <Text variant="darkest" fw="500" size="2">Disponível</Text>
          </Flex>
          <Flex gap="1" align="start" direction="column" >
            <Text variant="primary" size="3">
              {asCurrency(user?.customer?.invoiceLimit)}
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
    
  );
};

CreditLimit.displayName = "CreditLimit";
